module.exports = __webpack_public_path__ + "img/cooperative0_logo10.9db57ee5.jpg";